import { Pagination, PageSize } from '../Pagination';
import { getPageCount } from './utils/getPageCount';
import { useMemo } from 'react';
import { Box } from '../Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const styledPaginationDiv = {
  position: 'relative',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};
export const styledPaginationContainer = {
  width: '100%',
  display: 'inline-flex',
  justifyContent: 'center',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};
export const styledPaginationPageSizeContainer = {
  display: 'inline-flex',
  '@media (min-width: 690px)': {
    justifyContent: 'end',
    position: 'absolute',
    right: 0,
    top: 0,
    width: 'auto'
  },
  '@media (max-width: 690px)': {
    justifyContent: 'center',
    margin: '16px'
  },
  width: '100%',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};
export const StyledPagination = _ref => {
  let {
    pageSize,
    numberOfRows,
    onChange,
    onShowSizeChange,
    page,
    displayPageSizeSelector,
    defaultPageSize,
    paginationPageSizeOptions,
    id,
    enablePagination,
    ...rest
  } = _ref;
  const count = useMemo(() => getPageCount(pageSize, numberOfRows), [pageSize, numberOfRows]);
  return /*#__PURE__*/_jsxs(Box, {
    sx: styledPaginationDiv,
    children: [/*#__PURE__*/_jsx(Box, {
      sx: styledPaginationContainer,
      children: enablePagination && count > 1 && /*#__PURE__*/_jsx(Pagination, {
        count: count,
        showFirstButton: true,
        onChange: onChange,
        page: page,
        id: id,
        "data-testid": rest['data-testid']
      })
    }), /*#__PURE__*/_jsx(Box, {
      sx: styledPaginationPageSizeContainer,
      className: 'ids-table-page-size-selector-bottom',
      children: displayPageSizeSelector && /*#__PURE__*/_jsx(PageSize, {
        onShowSizeChange: onShowSizeChange,
        pageSize: pageSize,
        defaultPageSize: defaultPageSize,
        pageSizeOptions: paginationPageSizeOptions,
        size: "medium",
        id: id,
        "data-testid": rest['data-testid']
      })
    })]
  });
};